/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */

// Get the game time 

const getGameTime = (game, video) => {
    // Get the game time
    let gameTime = 0
    if (game) {

        let event = video.event
        let halfEvent = null
        let allEvents = game.events

        if (event) {
            for (let ev of allEvents) {
                if (ev.meta.type === "FullGameVideo") {
                    let hStart = ev.full_game_time
                    let hEnd = hStart + ev.dynamic.duration
                    if (
                        hStart <= event.full_game_time &&
                        event.full_game_time < hEnd
                    ) {
                        halfEvent = ev
                        break
                    }
                }
            }
            if (event.meta.type === "FullGameVideo") {
                gameTime = event.full_game_time
            } else if (halfEvent) {
                gameTime = event.full_game_time
            }
        }
        let videoElement = document.querySelector(
            ".VideoPlayer video.main-video[data-active=\"true\"]"
        )
        if (videoElement) {
            gameTime += videoElement.currentTime
        }
        gameTime = Math.round(gameTime)
    }
    return gameTime
}

export { getGameTime }
